var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCilCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_6397)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#47CF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4269 7.57374C13.9774 7.12305 13.4432 6.76563 12.8551 6.52203C12.267 6.27844 11.6365 6.15347 11 6.1543C8.32349 6.1543 6.15406 8.32417 6.15406 11.0002C6.15329 11.6368 6.2783 12.2672 6.52189 12.8553C6.76548 13.4434 7.12286 13.9776 7.5735 14.4272C8.02303 14.8779 8.5572 15.2353 9.14531 15.4789C9.73341 15.7225 10.3639 15.8474 11.0004 15.8466C13.6769 15.8466 15.8464 13.6767 15.8464 11.0007C15.8471 10.3641 15.7221 9.73369 15.4785 9.14559C15.2349 8.5575 14.8776 8.02332 14.4269 7.57374ZM11.0004 15.1971C8.68636 15.1971 6.80402 13.3143 6.80402 11.0007C6.80402 8.68704 8.68679 6.80426 11.0004 6.80426C13.3141 6.80426 15.1968 8.68704 15.1968 11.0007C15.1968 13.3143 13.3141 15.1971 11.0004 15.1971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 11.7605L8.77006 10.3746L8.30762 10.8019L10.2699 12.6151L13.6922 9.45271L13.2298 9.02539L10.2699 11.7605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_6397",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_6397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_6397",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilCheckCircle);
export default __webpack_public_path__ + "static/media/cil_check-circle.e41a97988412cf35991de6da337969be.svg";
export { ForwardRef as ReactComponent };